module.exports = __webpack_public_path__ + "static/media/system_resource_management_logo.8286bf9f.png";